import { useSelector } from 'react-redux';
import { getAllowedUserPermissions } from '../../helpers/common';
import {
  isAdminRole,
  CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC,
} from '../../consts/management/users/users';

export default function useLocationCapacitySheetSyncAccess() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  if (isAdminRole(currentUser?.role)) return { canView: true, canEdit: true };
  const { childIdToAccess } = getAllowedUserPermissions({
    permissions: currentUser?.permissions || [],
  });
  const access = childIdToAccess.get(CHILDREN_TAB_LOCATION_CAPACITY_SHEET_SYNC);
  return {
    canView: access === 'view' || access === 'edit',
    canEdit: access === 'edit',
  };
}
